import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { scrollToSection } from '../../utils/scrollTo';

const HashRedirect = ({ section }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
    const timer = setTimeout(() => scrollToSection(section), 400);
    return () => clearTimeout(timer);
  }, [navigate, section]);

  return null;
};

export default HashRedirect;